module.exports = __webpack_public_path__ + "static/media/tcomm.c875203e.png";